export default [
  {
    text: 'File Name',
    value: 'fileName',
    align: 'left',
    sortable: true,
    order: 0,
    hidable: true,
    hidden: false,
  },
    {
      text: 'Document No',
      value: 'documentNumber',
      order: 1,
      sortable: true,
      hidable: false,
      hidden: false,
    },
    {
      text: 'Title',
      value: 'documentTitle',
      align: 'left',
      sortable: true,
      order: 2,
      hidable: true,
      hidden: false,
    },
    {
      text: 'Revision',
      value: 'revisionNumber',
      order: 3,
      hidable: true,
      hidden: true,
    },
    {
      text: 'Type',
      value: 'documentTypeId',
      align: 'left',
      sortable: true,
      order: 4,
      hidable: true,
      hidden: false,
    },
  
  
    // {
    //   text: 'Tags',
    //   value: 'forgeTagsIds',
    //   order: 7,
    //   hidable: false,
    //   hidden: false,
    // },
  
    {
      text: 'Actions',
      value: 'actions',
      align: 'right',
      sortable: false,
      order: 8,
      hidable: true,
      hidden: false,
      width: '92px',
    },
  ];
  